import Repository from '../types/Repository';
import EntityType from '../types/Entity';
import EntityName from '../enums/EntityName';
import BookingRepository from './BookingRepository';
import ProjectSettingsRepository from './ProjectSettingsRepository';
import BlockedSlotRepository from './BlockedSlotRepository';

type RepositoryMap = {
  [key in EntityName]?: Repository<EntityType>;
};

class RepositoryFactory {
  private repositories: RepositoryMap = {
    [EntityName.Booking]: new BookingRepository(),
    [EntityName.BookingProjectSettings]: new ProjectSettingsRepository(),
    [EntityName.BlockedSlot]: new BlockedSlotRepository()
  };

  get<T extends EntityType>(entity: EntityName): Repository<T> {
    const repository = this.repositories[entity];

    if (!repository) {
      throw new Error(`No repository defined for entity ${entity}`);
    }

    return repository as Repository<T>;
  }
}

const factory = new RepositoryFactory();
export default factory;
